import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";

/**
 * Returns true if the event contains an exception with the passed error message.
 */
var matchErrorValue = function matchErrorValue(event, value) {
  var _event$exception, _event$exception$valu;

  return event === null || event === void 0 ? void 0 : (_event$exception = event.exception) === null || _event$exception === void 0 ? void 0 : (_event$exception$valu = _event$exception.values) === null || _event$exception$valu === void 0 ? void 0 : _event$exception$valu.reduce(function (acc, exception) {
    return acc || exception.value === value;
  }, false);
};
/**
 * Returns true if the event contains an exception with a stacktrace path including the passed value.
 */


var traceContainsScript = function traceContainsScript(event, scriptName) {
  var _event$exception2;

  var allFrames = event === null || event === void 0 ? void 0 : (_event$exception2 = event.exception) === null || _event$exception2 === void 0 ? void 0 : _event$exception2.values.reduce(function (acc, exception) {
    var _exception$stacktrace;

    return acc.concat((_exception$stacktrace = exception.stacktrace) === null || _exception$stacktrace === void 0 ? void 0 : _exception$stacktrace.frames);
  }, []);
  return allFrames.reduce(function (acc, frame) {
    return acc || (frame === null || frame === void 0 ? void 0 : frame.filename.includes(scriptName));
  }, false);
};
/**
 * Check if an event should be ignored client-side.
 * @param {*} event Sentry event
 * @returns boolean true if event should be ignored
 */


export var isEventExcluded = function isEventExcluded(event) {
  // A Bing tracking library error, no effect to users
  // https://nerdwallet.atlassian.net/browse/SEO-630
  if (matchErrorValue(event, 'UET is not defined')) {
    return true;
  } // A Pinterest tracking pixel issue, no effect to users


  if (matchErrorValue(event, "'undefined' is not a function (evaluating 'n.includes(\"application/json\")')") && traceContainsScript(event, 'https://s.pinimg.com')) {
    return true;
  }

  return false;
};